// Font d'interfaccia: Nunito (Davide 2026-08-13). Self-hosted come gli altri
// via @fontsource — il container non esce su Internet, un <link> a Google Fonts
// darebbe testo invisibile in produzione.
//
// Quattro pesi e non tre: Nunito HA il 600, che Roboto non aveva. Prima i
// `font-semibold` sparsi nel codice cadevano sul 700 per la regola di font
// matching; ora rendono col peso che chiedono.
import "@fontsource/nunito/400.css";
import "@fontsource/nunito/500.css";
import "@fontsource/nunito/600.css";
import "@fontsource/nunito/700.css";
import "@fontsource/source-serif-4/400.css";
import "@fontsource/source-serif-4/500.css";
import "@fontsource/source-serif-4/600.css";
import "@fontsource/outfit/500.css";
import "@fontsource/outfit/600.css";
import "@fontsource/outfit/700.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { applyInitialTheme } from "./shared/useTheme";
import "./styles/globals.css";

// Audit 2026-05-13 #8: applichiamo il tema PRIMA del primo render per
// evitare flash of light theme (FOLT) quando l'utente ha gia' scelto dark.
applyInitialTheme();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
